import * as React from 'react';
import { useDepots } from '../../hooks/useDepots';
import { useData } from '../../core/context/ProvidersContext';
import styles from './AdminPanel.module.scss';

export const DepotsManager: React.FC = () => {
  const data = useData();
  const { depots, loading, refresh } = useDepots();
  const [newTitle, setNewTitle] = React.useState('');
  const [editingId, setEditingId] = React.useState<number | null>(null);
  const [editValue, setEditValue] = React.useState('');

  const handleAdd = async (): Promise<void> => {
    if (!newTitle.trim()) return;
    await data.addDepot(newTitle.trim());
    setNewTitle('');
    refresh();
  };

  const handleSaveEdit = async (id: number): Promise<void> => {
    await data.updateDepot(id, editValue.trim());
    setEditingId(null);
    refresh();
  };

  const handleDelete = async (id: number): Promise<void> => {
    if (!confirm('Supprimer ce dépôt ?')) return;
    await data.deleteDepot(id);
    refresh();
  };

  if (loading) return <div className={styles.loading}>Chargement…</div>;

  return (
    <div className={styles.crud}>
      <h3>Dépôts ({depots.length})</h3>
      <div className={styles.addRow}>
        <input
          className={styles.input}
          placeholder="Nom du dépôt"
          value={newTitle}
          onChange={e => setNewTitle(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') handleAdd(); }}
        />
        <button className={styles.btnPrimary} onClick={handleAdd}>Ajouter</button>
      </div>
      <table className={styles.table}>
        <thead>
          <tr><th>Nom</th><th style={{ width: 200 }}>Actions</th></tr>
        </thead>
        <tbody>
          {depots.map(d => (
            <tr key={d.Id}>
              <td>
                {editingId === d.Id ? (
                  <input
                    className={styles.input}
                    value={editValue}
                    onChange={e => setEditValue(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter') handleSaveEdit(d.Id); }}
                    autoFocus
                  />
                ) : d.Title}
              </td>
              <td>
                {editingId === d.Id ? (
                  <>
                    <button className={styles.btnSmall} onClick={() => handleSaveEdit(d.Id)}>OK</button>
                    <button className={styles.btnSmall} onClick={() => setEditingId(null)}>Annuler</button>
                  </>
                ) : (
                  <>
                    <button
                      className={styles.btnSmall}
                      onClick={() => { setEditingId(d.Id); setEditValue(d.Title); }}
                    >Modifier</button>
                    <button
                      className={styles.btnSmallDanger}
                      onClick={() => handleDelete(d.Id)}
                    >Supprimer</button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
